import React from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { translateFr as tfr } from "@/i18n";

import { dateLocale } from "@/lib/utils";
const MODE_LABEL = {
  upgrade: tfr("Mise à niveau immédiate après confirmation."),
  downgrade: tfr("Le changement prendra effet à la fin de votre période en cours."),
  trial: tfr("L'essai continue — cette offre démarrera à l'activation de votre abonnement."),
  same: tfr("Vous êtes déjà sur cette offre."),
};

export default function ChangeBar({ currentPlan, selectedPlan, changeMode, isTrial, busy, onCancel, onDetails, onConfirm, onActivate }) {
  if (!selectedPlan) return null;
  return (
    <div
      className="sticky bottom-4 z-20 rounded-[14px] border border-border bg-surface/95 backdrop-blur-xl px-4 py-3.5 shadow-xl shadow-black/10 dark:shadow-black/40 pb-[max(0.875rem,env(safe-area-inset-bottom))]"
      data-testid="plan-confirm-bar"
      role="region"
      aria-live="polite"
      aria-label={tfr("Confirmation du changement d'offre")}
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div className="min-w-0">
          <p className="text-sm font-semibold flex items-center gap-1.5 flex-wrap" data-testid="plan-bar-transition">
            <span className="text-muted-foreground font-medium">{currentPlan?.name}</span>
            <ArrowRight className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />
            <span>{selectedPlan.name}</span>
            {selectedPlan.prices?.monthly && (
              <span className="text-muted-foreground font-normal tabular-nums">
                · {new Intl.NumberFormat(dateLocale(), { style: "currency", currency: "EUR" }).format(selectedPlan.prices.monthly.amount / 100)} / mois
              </span>
            )}
          </p>
          <p className="text-[11px] text-muted-foreground mt-0.5">{MODE_LABEL[changeMode] || ""}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0 flex-wrap">
          <Button variant="ghost" size="sm" className="h-11 sm:h-10" onClick={onCancel} data-testid="plan-bar-cancel">
            {tfr("Annuler")}
          </Button>
          {onDetails && (
            <Button variant="outline" size="sm" className="h-11 sm:h-10" onClick={onDetails} data-testid="plan-bar-details">
              {tfr("Voir les détails")}
            </Button>
          )}
          {isTrial ? (
            <Button size="sm" className="h-11 sm:h-10 gap-1.5" onClick={onActivate} disabled={busy} data-testid="plan-bar-activate">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Activer maintenant
            </Button>
          ) : (
            <Button size="sm" className="h-11 sm:h-10 gap-1.5" onClick={onConfirm} disabled={busy || changeMode === "same"} data-testid="plan-bar-confirm">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Confirmer le changement
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
